export default __webpack_public_path__ + "static/media/img_empty_state.013ee6fc.svg";